import { Helmet } from 'react-helmet-async';
// sections
import { Card, Container } from '@mui/material';
import Login from '../sections/auth/Login';
import Footer from '../layouts/main/Footer';


// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Login |Proclaimz</title>
      </Helmet>
          <Container >
              <Card sx={{
                  width: { xs: 400, sm: 500, md: 650 }, height: 460, p: 2, position: 'absolute', borderRadius: 3, alignItems: 'center',
                  top: '50%', left: '50%', transform: 'translate(-50%, -50%)'
              }}>
                  <Login />
              </Card>
          </Container >
          <Footer /> 
    </>
  );
}
